export const tinyMCEdevKey = "nfcz2zg0p5op5qy38ll9u65r5ym8ebxa6qukal3tf9puhcrv";